import type { QueryFilterType } from '~/types/database-query.d';

export const cleanFilterValue = (filterType: QueryFilterType, filterValue: unknown) => {
  if (Array.isArray(filterValue)) {
    return filterType == 'in' || filterType == 'not.in'
      ? `(${filterValue.join(',')})`
      : `{${filterValue.join(',')}}`;
  }
  return filterValue;
};
